<template>
    <div class="absolute inset-0 flex items-center justify-center z-50" :class="overlayClasses">
        <font-awesome-icon
            class="animate-spin transition-all text-dark"
            size="5x"
            :icon="['fas', 'tire']"
        ></font-awesome-icon>
    </div>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {computed} from "vue";

export default {
    components: {
        FontAwesomeIcon
    },
    props: {
        blur: Boolean
    },
    setup(props) {
        const overlayClasses = computed(() => {
            return {
                'backdrop-blur': props.blur
            }
        });

        return {
            overlayClasses
        };
    }
}
</script>

<style scoped>

</style>
